<template>
    <AccountSharedLayout class="AccountResetView">
        <span slot="title">{{ $t('title') }}</span>

        <span slot="subtitle">{{ $t('subtitle') }}</span>

        <form slot="main" name="form" @submit.prevent="submit()">
            <FormGroup v-model.trim="password" :label="$t('password')" :v="$v.password" type="password" />

            <div class="footer">
                <div v-if="serverError" class="alert-danger">
                    <span>{{ $t('failed') }}</span>
                    <br />
                    {{ serverError }}
                </div>

                <SubmitButton class="submitButton" :label="$t('submit')" :working="working" :disabled="$v.$invalid" />
            </div>
        </form>
    </AccountSharedLayout>
</template>

<translations>
  title: 'Reset your password'
  title_no: 'Sett nytt passord'
  subtitle: 'You can now set a new password for your account.'
  subtitle_no: 'Du kan nå sette et nytt passord for din brukerkonto'
  password: 'New password'
  password_no: 'Nytt passord'
  failed: 'Failed to reset password.'
  failed_no: 'En feil skjedde når vi prøvde å sette nytt passord.'
  submit: 'Set my password'
  submit_no: 'Sett nytt passord'
</translations>

<script>
import AccountSharedLayout from '../components/AccountSharedLayout';
import FormGroup from '../components/FormGroup';
import SubmitButton from '../components/SubmitButton';

import { required, minLength } from 'vuelidate/lib/validators';

export default {
    components: { AccountSharedLayout, FormGroup, SubmitButton },
    props: {
        token: {
            type: String,
            required: true
        }
    },
    data() {
        return {
            working: false,
            serverError: '',

            password: ''
        };
    },
    methods: {
        async submit() {
            if (this.$v.$invalid) {
                return;
            }
            this.working = true;
            this.serverError = '';

            try {
                await this.$store.dispatch('moduleAuth/resetPassword', { token: this.token, password: this.password });
            } catch (err) {
                this.serverError = err.message;
                return;
            } finally {
                this.working = false;
            }
            this.$router.push({ name: 'AccountLoginView' });
        }
    },
    validations: {
        password: {
            required,
            minLength: minLength(8)
        }
    }
};
</script>

<style lang="scss" scoped>
.AccountResetView {
    padding: 1em;
}
.FormGroup {
    &:not(:first-child) {
        margin-top: 1em;
    }
}
.footer {
    margin-top: 2em;
}
.submitButton {
    width: 100%;
}
.alert-danger {
    background-color: #edc8c5;
    color: #c38a8a;
    padding: 1em;
    margin-bottom: 1em;
}
</style>
